import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useAddressTypeReducer = () =>
  useSelector((state: ApplicationState) => state.addressType);
